import React from 'react';

import { bemBlock } from '../../modules/bem';

import { TableBody } from './TableBody';
import { TableCell } from './TableCell';
import { TableHead } from './TableHead';
import { TableHeadCell } from './TableHeadCell';
import { TableProvider } from './TableProvider';
import { TableRow } from './TableRow';
import { TableSortAction } from './TableSortAction';

import './Table.less';

const block = bemBlock('table');

const DEFAULT_VIRTUALIZATION_THRESHOLD = 256;

export type TableProps = React.TableHTMLAttributes<HTMLTableElement> & {
  rowsCount?: number;
  withBorderRadius?: boolean;
  virtualizationThreshold?: number;
};

const TableRoot = React.forwardRef<HTMLTableElement, TableProps>(function Table(
  {
    className,
    rowsCount = 0,
    withBorderRadius = true,
    virtualizationThreshold = DEFAULT_VIRTUALIZATION_THRESHOLD,
    ...passProps
  },
  ref,
) {
  const shouldVirtualize = rowsCount > virtualizationThreshold;

  return (
    <TableProvider shouldVirtualize={shouldVirtualize}>
      <table
        ref={ref}
        className={block({
          modifiers: { withBorderRadius, virtualized: shouldVirtualize },
          extra: className,
        })}
        {...passProps}
      />
    </TableProvider>
  );
});

export const Table = Object.assign(TableRoot, {
  Head: TableHead,
  Body: TableBody,
  Row: TableRow,
  HeadCell: TableHeadCell,
  Cell: TableCell,
  SortAction: TableSortAction,
});
